module.exports = __webpack_public_path__ + "static/media/wifi.9e660e50.svg";